import { combineReducers } from "redux";

import facetReducer from "./facet/facet.reducer";
import { IFacetState } from "./facet/facet.types";
import locationReducer from "./location/location.reducer";
import { ILocationState } from "./location/location.types";
import pageReducer from "./page/page.reducer";
import { IPageState } from "./page/page.types";
import translationReducer from "./translation/translation.reducer";
import { ITranslationState } from "./translation/translation.types";
import UIReducer from "./ui/ui.reducer";
import { IUIState } from "./ui/ui.types";
import userReducer from "./user/user.reducer";
import jobsFeedReducer from "./jobsFeed/jobsFeed.reducer";
import { IUserState } from "./user/user.types";
import { IJobsFeedState } from "./jobsFeed/jobsFeed.types";

export interface IApplicationState {
  ui: IUIState;
  user: IUserState;
  translation: ITranslationState;
  page: IPageState;
  location: ILocationState;
  facet: IFacetState;
  jobsFeed: IJobsFeedState;
}

export const reducers = combineReducers({
  ui: UIReducer,
  user: userReducer,
  translation: translationReducer,
  page: pageReducer,
  location: locationReducer,
  facet: facetReducer,
  jobsFeed: jobsFeedReducer,
});
